import React from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colors } from '_styles';
import { _ } from '_locales';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 19px 0;
  box-sizing: border-box;

  ${(parentWidth < 390) && css`
    flex-direction: column;
  `};
`;

const Button = styled.button`
  background-color: ${colors.RC_ACTION};
  border: none;
  cursor: pointer;
  border-radius: 7px;
  color: white;
  font-size: 14px !important;
   
  max-width: 182px;
  margin: 5px 11px;
  padding: 13px;
  flex: 1;
  text-transform: capitalize;

  ${(parentWidth < 390) && css`
    width: 100%;
  `};
`;

const SuccessMessageBox = styled.div`
  text-align: center;
  max-width: 400px;
  margin: 30px auto 6px;
`;

const SuccessMessageTitle = styled.h1`
  font-size: 18px !important;
   
`;

const SuccessMessageText = styled.span`
  font-size: 16px !important;
   
  line-height: 1.7em;
  text-align: center;
  max-width: 400px;
  /* margin: auto 20% auto 20%; */
`;

const ReminderData = styled.span`
  color: ${colors.RC_ACTION};
`;

const ReminderSuccessScreen = ({ data }) => {
  const history = useHistory();

  const {
    day,
    hour,
    method,
    communication,
  } = data || {};

  return (
    <Container>
      <SuccessMessageBox>
        {
          !data
          && <SuccessMessageTitle>{_('reminder.your_reminder_saved')}</SuccessMessageTitle>
        }
        <SuccessMessageText>
          {
            data ? (
              (
                <span>
                  {_('reminder.you_are_all_set!_your_weekly_reminder_is_scheduled_for')}
                  {' '}
                  <ReminderData>{moment(day, ['dd']).format('dddd')}</ReminderData>
                  {' '}
                  {_('reminder.at')}
                  {' '}
                  <ReminderData>{moment(hour, ['h:mm']).format('h:mm A')}</ReminderData>
                  {' '}
                  {_('reminder.it_will_be_sent_via')}
                  {' '}
                  <ReminderData>{method}</ReminderData>
                  {' '}
                  {_('reminder.to')}
                  {' '}
                  <ReminderData>{communication}</ReminderData>
                </span>
              )
            ) : _('reminder.would_you_like_to_create_new_reminder')
          }
        </SuccessMessageText>
      </SuccessMessageBox>
      <ButtonContainer>
        <Button onClick={() => history.goBack()} aria-label="set another reminder">
          {_('reminder.set_another_reminder')}
        </Button>
        <Button onClick={() => history.push('/cal')} aria-label="go back to the calendar">
          {_('reminder.exit')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default ReminderSuccessScreen;
